import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App';
import './config/interceptor'

import 'mapbox-gl/dist/mapbox-gl.css'
import './index.css'

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
